module.exports = __webpack_public_path__ + "master_calendar.png?d02caf9c2a29fd87fb37ae5e29211796";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/newborn/master_calendar.png
// module id = 16
// module chunks = 0